import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppRoutesName } from '../../const/AppRoutesName';
import { CanDeactivateGuard } from '../../gards/can-deactivate-guard.service';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.CONGRESSES,
    loadComponent: () =>
      import('./congresses.component').then((m) => m.CongressesComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.CONGRESSES + '/:slug' + '/:id',
    loadComponent: () =>
      import('./congres/congres.component').then((m) => m.CongresComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.PROJECT_ROUTE,
    loadComponent: () =>
      import('./project/project.component').then((m) => m.ProjectComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.GROUP_ENTERPRISE_ROUTE,
    loadComponent: () =>
      import('./group-enterprise/group-enterprise.component').then(
        (m) => m.GroupEnterpriseComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.CONGRESSES,
    loadComponent: () =>
      import('./congresses.component').then((m) => m.CongressesComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.CONGRESSES + '/:slug' + '/:id',
    loadComponent: () =>
      import('./congres/congres.component').then((m) => m.CongresComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.PROJECT_ROUTE,
    loadComponent: () =>
      import('./project/project.component').then((m) => m.ProjectComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.GROUP_ENTERPRISE_ROUTE,
    loadComponent: () =>
      import('./group-enterprise/group-enterprise.component').then(
        (m) => m.GroupEnterpriseComponent,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CongressesModule {}
